<template>
  <div class="container  pull-up">
    <div class="row">
      <div class="col-lg-12">

        <div class="card m-b-30 ">
          <div class="card-header">
            <p class="m-b-0 opacity-50">
              {{ $t('text.fields_with') }}
              <req/>
              {{ $t('text.are_required') }}
            </p>
            <hr>
          </div>
          <div class="card-body ">
            <!-- Profile Picture Upload Section -->
            <div class="text-center mb-4">
              <div class="profile-picture-container">
                <img
                  v-if="profilePicturePreview"
                  :src="profilePicturePreview"
                  class="profile-picture-preview"
                  :alt="$t('customer.label.profile_picture')"
                />
                <div v-else class="profile-picture-placeholder">
                  <i class="mdi mdi-account-circle" style="font-size: 100px; color: #ccc;"></i>
                </div>
                <div class="mt-2">
                  <el-upload
                    ref="upload"
                    :show-file-list="false"
                    :before-upload="handleProfilePictureUpload"
                    accept="image/*"
                    action="#"
                    :auto-upload="false"
                    class="profile-picture-upload"
                  >
                    <el-button size="small" type="primary" icon="mdi mdi-camera">
                      {{ $t('button.upload') }}
                    </el-button>
                  </el-upload>
                  <el-button
                    v-if="profilePicturePreview"
                    size="small"
                    type="danger"
                    icon="mdi mdi-delete"
                    @click="removeProfilePicture"
                    class="ml-2"
                  >
                    {{ $t('button.remove') }}
                  </el-button>
                </div>
              </div>
            </div>

            <el-form size="medium" label-position="left" ref="form" :rules="rules" :model="form"
                     label-width="150px" class="p-r-15">
              <el-form-item :label="$t('customer.label.name')" prop="name">
                <el-input v-model="form.name" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('customer.label.address')" prop="address">
                <el-input v-model="form.address" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('customer.label.nic')" prop="nic">
                <el-input v-model="form.nic" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('customer.label.phone')" prop="phone">
                <el-input v-model="form.phone" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('customer.label.email')" prop="email">
                <el-input v-model="form.email" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('customer.label.country')" prop="country_id">
                <el-select clearable v-model="form.country_id" filterable :placeholder="$t('text.click_to_select')" class="f-w"
                           default-first-option>
                  <el-option v-for="country in countries" :key="country.id" :label="country.name" :value="country.id">
                    <span>{{ country.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('customer.label.store')" prop="store_id">
                <el-select clearable v-model="form.store_id" filterable :placeholder="$t('text.click_to_select')" class="f-w"
                           default-first-option>
                  <el-option v-for="store in stores" :key="store.id" :label="store.name" :value="store.id">
                    <span>{{ store.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('customer.label.price_list')" prop="price_list">
                <el-select clearable v-model="form.price_list" filterable :placeholder="$t('text.click_to_select')" class="f-w"
                           default-first-option>
                  <el-option v-for="pl in price_lists" :key="pl.id" :label="pl.name" :value="pl.id">
                    <span>{{ pl.name }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('customer.label.gender')" prop="gender">
                <el-radio-group v-model="form.gender">
                  <el-radio label="m">{{ $t('customer.gender.male') }}</el-radio>
                  <el-radio label="f">{{ $t('customer.gender.female') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$t('customer.label.note')" prop="note">
                <el-input type="textarea" v-model="form.note" :rows="3" />
              </el-form-item>
              <el-form-item class="text-center">
                <div class="row">
                  <div class="col"></div>
                  <div class="col"></div>
                  <div class="col">
                    <el-button icon="mdi mdi-content-save" :loading="loading" type="primary" class="btn-block" @click.prevent="saveCustomer">
                      {{ isEditing ? $t('button.save_changes') : $t('customer.button.create') }}
                    </el-button>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Create',
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      price_lists: [],
      stores: [],
      countries: [],
      profilePicturePreview: null,
      form: {
        name: '',
        nic: '',
        address: '',
        email: '',
        phone: '',
        price_list: null,
        store_id: null,
        country_id: null,
        photo: null,
        note: '',
        gender: 'm'
      },
      rules: {
        name: [
          { required: true, trigger: 'blur' }
        ],
        address: [
          { required: false, trigger: 'blur' }
        ],
        email: [
          { required: false, trigger: 'blur' }
        ],
        nic: [
          { required: false, trigger: 'blur' }
        ],
        phone: [
          { required: false, trigger: 'blur' }
        ],
        price_list: [
          { required: false, trigger: 'blur' }
        ],
        store_id: [
          { required: false, trigger: 'blur' }
        ],
        country_id: [
          { required: false, trigger: 'blur' }
        ],
        gender: [
          { required: false, trigger: 'blur' }
        ],
        note: [
          { required: false, trigger: 'blur' }
        ]
      },
      loading: false
    }
  },
  computed: {
    isEditing () {
      return !!this.customer || !!this.$route.params.id
    }
  },
  methods: {
    handleProfilePictureUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error(this.$t('customer.error.upload_image_format'))
        return false
      }
      if (!isLt2M) {
        this.$message.error(this.$t('customer.error.upload_file_size'))
        return false
      }

      // Convert to base64
      const reader = new FileReader()
      reader.onload = (e) => {
        this.form.photo = e.target.result
        this.profilePicturePreview = e.target.result
      }
      reader.readAsDataURL(file)

      return false // Prevent default upload
    },

    removeProfilePicture () {
      this.form.photo = null
      this.profilePicturePreview = null
    },

    async saveCustomer () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await this.withLoading(async () => {
              let data
              if (this.isEditing) {
                const customerId = this.customer ? this.customer.id : this.$route.params.id
                data = await this.$customerService.updateCustomer(customerId, this.form)
                this.showSuccess(this.$t('customer.message.updated'))
              } else {
                data = await this.$customerService.createCustomer(this.form)
                this.showSuccess(this.$t('customer.message.created'))
              }
              this.$router.push({ name: 'customers' })
            }, 'loading')
          } catch (error) {
            // Error is already handled by the global interceptor
            console.log('Component caught error in saveCustomer:', error)
          }
        }
      })
    },
    clearFields () {
      this.$refs.form.resetFields()
      this.profilePicturePreview = null
      this.form.photo = null
    },

    async loadCustomerData () {
      if (this.customer) {
        this.form = {
          name: this.customer.name || '',
          nic: this.customer.nic || '',
          address: this.customer.address || '',
          email: this.customer.email || '',
          phone: this.customer.phone || '',
          price_list: this.customer.price_list_id || null,
          store_id: this.customer.store_id || null,
          country_id: this.customer.country_id || null,
          photo: this.customer.photo || null,
          note: this.customer.note || '',
          gender: this.customer.gender || 'male'
        }

        if (this.customer.photo) {
          this.profilePicturePreview = this.customer.photo
        }
      } else if (this.$route.params.id) {
        // Fetch customer data from API
        try {
          const customerData = await this.$customerService.getCustomer(this.$route.params.id)
          this.form = {
            name: customerData.name || '',
            nic: customerData.nic || '',
            address: customerData.address || '',
            email: customerData.email || '',
            phone: customerData.phone || '',
            price_list: customerData.price_list_id || null,
            store_id: customerData.store_id || null,
            country_id: customerData.country_id || null,
            photo: customerData.photo || null,
            note: customerData.note || '',
            gender: customerData.gender || 'm'
          }

          if (customerData.photo) {
            this.profilePicturePreview = customerData.photo
          }
        } catch (error) {
          console.log('Error loading customer data:', error)
          this.$router.push({ name: 'customers' })
        }
      }
    }
  },
  async mounted () {
    this.$emit('parent-title', this.isEditing ? this.$t('customer.title.edit') : this.$t('customer.title.create'))

    // Load stores
    this.$storeService.getStores()
      .then(data => {
        this.stores = data
      })
      .catch(error => {
        console.log('Error loading stores:', error)
      })

    // Load countries
    this.$countryService.getCountries()
      .then(data => {
        this.countries = data
      })
      .catch(error => {
        console.log('Error loading countries:', error)
      })

    // Load price lists
    this.$configService.getPriceLists()
      .then(data => {
        this.price_lists = data
        if (!this.isEditing && data.length > 0) {
          this.form.price_list = data[0].id
        }
      })

    // Load customer data if editing
    await this.loadCustomerData()
  }
}
</script>

<style scoped>
.profile-picture-container {
  display: inline-block;
  text-align: center;
}

.profile-picture-preview {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.profile-picture-placeholder {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 3px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
  margin: 0 auto;
}

.profile-picture-upload {
  display: inline-block;
}

.ml-2 {
  margin-left: 8px;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

.mt-2 {
  margin-top: 0.5rem;
}
</style>
